import ResizeObserver from 'resize-observer-polyfill'
window.ResizeObserver = ResizeObserver

import 'isomorphic-unfetch' // TODO: remove once we're on Node 18
